import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  profileWorksMetaTitle: {
    id: 'profile-works.meta.title-2',
    defaultMessage: 'Works by {name}',
  },
  profileWorksMetaDescription: {
    id: 'profile-works.meta.description',
    defaultMessage:
      'Listen to all works by {name} in stunning, lossless sound quality. Stream now on IDAGIO',
  },
  profileWorksMetaKeywords: {
    id: 'profile-works.meta.keywords',
    defaultMessage: '{name} classical works,',
  },
  profileAlbumsMetaTitle: {
    id: 'profile-albums.meta.title-2',
    defaultMessage: 'Albums by {name}',
  },
  profileAlbumsOgDescription: {
    id: 'profile-albums.og.description',
    defaultMessage: 'Stream {name} albums on IDAGIO',
  },
  profileAlbumsMetaDescription: {
    id: 'profile-albums.meta.description-2',
    defaultMessage: '{name}: Discography. Stream now on IDAGIO',
  },
  profileAlbumsMetaKeywords: {
    id: 'profile-albums.meta.keywords',
    defaultMessage: '{name} classical albums,',
  },
  profileRecordingsMetaTitle: {
    id: 'profile-recordings.meta.title-2',
    defaultMessage: 'Recordings by {name}',
  },
  profileRecordingsOgDescription: {
    id: 'profile-recordings.og.description',
    defaultMessage: 'Stream {name} recordings on IDAGIO',
  },
  profileRecordingsMetaDescription: {
    id: 'profile-recordings.meta.description',
    defaultMessage:
      'Listen to all recordings by {name} in stunning, lossless sound quality. Stream now on IDAGIO',
  },
  profileRecordingsMetaKeywords: {
    id: 'profile-recordings.meta.keywords',
    defaultMessage: '{name} classical recordings,',
  },
  profilePlaylistsMetaTitle: {
    id: 'profile-playlists.meta.title-2',
    defaultMessage: 'Playlists by {name}',
  },
  profilePlaylistsMetaDescription: {
    id: 'profile-playlists.meta.description',
    defaultMessage:
      'Listen to all playlists by {name} in stunning, lossless sound quality. Stream now on IDAGIO',
  },
  profilePlaylistsMetaKeywords: {
    id: 'profile-playlists.meta.keywords',
    defaultMessage: '{name} playlists,',
  },
  share: {
    id: 'profile-head.share',
    defaultMessage: 'Share artist',
  },
  profileAboutMetaDescription: {
    id: 'profile-about.meta.description',
    defaultMessage:
      'Listen to works, recordings and albums by {name} in stunning, lossless sound quality. Stream now on IDAGIO',
  },
  profileAboutMetaKeywords: {
    id: 'profile-about.meta.keywords',
    defaultMessage: '{name} classical music,',
  },
  profileAboutRecommendedAlbums: {
    id: 'profile-about.recommended-albums',
    defaultMessage: 'Recommended Albums',
  },
  profileAboutRecommendedArtists: {
    id: 'profile-about.recommended-artists',
    defaultMessage: 'You might also enjoy...',
  },
  profileAboutLatestReleases: {
    id: 'profile-about.latest-releases',
    defaultMessage: 'Latest Releases',
  },
  profileAboutFeaturedOn: {
    id: 'profile-about.featured-on',
    defaultMessage: 'Featured On',
  },
  profileAboutConcerts: {
    id: 'profile-about.concerts-events',
    defaultMessage: 'Concerts and Events',
  },
});
